import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
// import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import { getFinanceManagementTableAsync } from './ManagementAppFinanceStore/managementAppFinanceSlice';
import useToast from '../../../hooks/useToast';
import { MANAGEMENT_FINANCE_TABLE_COLUMN } from '../columns';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
// import { DEMO_MGMENT_FINANCE_TABLE_DATA } from '../constant';

function ManagementAppFinanceScreen() {
  const dispatch = useDispatch();
  const { ErrorToast } = useToast();
  const [transactionId, setTransactionId] = useState(null);
  const [particularsFilter, setParticularsFilter] = useState(null);
  const [statusFilter, setStatusFilter] = useState(null);
  const [page, setPage] = useState(1);

  const { mgmentTableCount, mgmentTableData } = useSelector(
    ({ managementAppFinanceReducer }) => {
      return {
        mgmentTableCount: managementAppFinanceReducer.mgmentFinanceTableCount,
        mgmentTableData: managementAppFinanceReducer.mgmentFinanceTableData,
      };
    }
  );

  useEffect(() => {
    getInvoiceData();
  }, [transactionId, particularsFilter, statusFilter, page]);

  const handlePageChange = (val) => {
    if (val === page) return;
    setPage(val);
  };

  const getInvoiceData = () => {
    const payload = {};
    payload.page = page;
    payload.limit = 8;
    if (transactionId) payload.transactionId = transactionId;
    if (particularsFilter) payload.particulars = particularsFilter;
    if (statusFilter) payload.invoiceStatus = statusFilter;

    dispatch(getFinanceManagementTableAsync(payload))
      .unwrap()
      .then((res) => {
        if (res && res.status > 299) {
          ErrorToast(res.message);
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const handleParticularsFilterSelection = (e) => {
    const value = e.target.value;
    setParticularsFilter(value);
  };
  const handleStatusFilterSelection = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
  };

  return (
    <Box>
      <Box mb={4} fontSize={22} fontWeight={'fontWeightMedium'}>
        Management App Finance
      </Box>
      <Box mb={2} style={{ display: 'flex', alignItems: 'center' }}>
        <Box width={300}>
          <BuzzInput
            placeholder={'Search by transaction id'}
            search
            flex={2}
            mr={2}
            value={transactionId}
            onChange={(e) => setTransactionId(e.target.value)}
            size="small"
            // onSubmitEditing={handleSearchTransactionId}
          />
        </Box>
        <Box mr={2} width={200}>
          <BuzzSelect
            labelKey="label"
            valueKey="value"
            width={200}
            size={'small'}
            placeholder="Particulars"
            value={particularsFilter}
            onChange={handleParticularsFilterSelection}
            options={[
              { label: 'Referral', value: 'Referral' },
              { label: 'Discount', value: 'Discount' },
              { label: 'Admission Form Fee', value: 'Admission Form Fee' },
              { label: 'Admission Fee', value: 'Admission Fee' },
              { label: 'Gift Voucher', value: 'gift voucher' },
              { label: 'Subscription', value: 'Subscription' },
              {
                label: 'Communication Balance TopUp',
                value: 'Communication Balance TopUp',
              },
            ]}
          />
        </Box>
        <Box mr={2} width={200}>
          <BuzzSelect
            labelKey="label"
            valueKey="value"
            size={'small'}
            placeholder="Status"
            value={statusFilter}
            onChange={handleStatusFilterSelection}
            options={[
              { label: 'Unpaid', value: 'unpaid' },
              { label: 'Paid', value: 'paid' },
            ]}
          />
        </Box>
      </Box>

      <Box>
        <BuzzTable
          columns={MANAGEMENT_FINANCE_TABLE_COLUMN}
          // data={DEMO_MGMENT_FINANCE_TABLE_DATA}
          data={mgmentTableData}
        />
        <Box display="flex" justifyContent="center">
          <BuzzPagination
            onClick={handlePageChange}
            total={mgmentTableCount}
            pageNo={page}
            defaultPage={1}
            perPage={8}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default ManagementAppFinanceScreen;
